import { GenericActivityListSort } from 'src/models/genericActivityList';
import { AbstractQuery } from 'src/models/query';

export class PhoneCallQuery extends AbstractQuery {
	name = 'IFS_Desktop_Query_Queries_PhoneCall_GetTheDetailsForThePhoneCallQuery';
	sort = [];
	apiVersion = 3;

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
	}
}

export class GetTheOutgoingCallConfigurationForTheUserQuery extends AbstractQuery {
	name = 'IFS_PhoneCall_Query_Queries_GetTheOutgoingCallConfigurationForTheUserQuery';
	sort = [];
	subscribeForUpdates = true;
	constructor() {
		super();

		this.cacheable = false;
		this.ignoreCachedResult = true;
	}
}

export class GetTheNextOutgoingCallIdForACalledNumberAfterAGivenTimestampQuery extends AbstractQuery {
	name = 'IFS_PhoneCall_Query_Queries_GetTheNextOutgoingCallIdForACalledNumberAfterAGivenTimestampQuery';
	sort = [];
	subscribeForUpdates = false;
	constructor(number: string, timestamp: string) {
		super();

		this.cacheable = false;
		this.ignoreCachedResult = true;
		this.parameters.push({ number: number });
		this.parameters.push({ timestamp: timestamp });
	}
}

export class GetThePhoneticSimilarPhoneBookEntriesQuery extends AbstractQuery {
	name = 'IFS_Desktop_Query_Queries_PhoneCall_GetThePhoneticSimilarPhoneBookEntriesQuery';
	sort = [];
	subscribeForUpdates = true;
	constructor() {
		super();

		this.cacheable = false;
		this.ignoreCachedResult = true;
	}
}

export class GetThePhoneBookQueryQuery extends AbstractQuery {
	name = 'IFS_Desktop_Query_Queries_PhoneCall_GetThePhoneBookQuery';
	subscribeForUpdates = true;
	constructor(searchString: string, page: number, limit: number, sort: Array<GenericActivityListSort>) {
		super();

		this.parameters.push({ searchString: searchString });
		this.page = page;
		this.limit = limit;
		this.sort = sort;
		this.cacheable = false;
		this.ignoreCachedResult = true;
	}
}
